import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { IMPACT_SECTION_IDS } from '~/constants/impactSectionIds';
import { GHG_ESTIMATOR_CONCEPT_ID } from '~/constants/concepts';
import { TemplateEngineContext } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    impactGoal: null,
    impactSolution: null,
    impact: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var growthFactorTitle = computed(function () {
      var _props$impact;
      return ((_props$impact = props.impact) === null || _props$impact === void 0 ? void 0 : _props$impact.conceptId) === GHG_ESTIMATOR_CONCEPT_ID ? $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.growthFactor.titleReducedCo2') : $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.growthFactor.title');
    });
    return {
      __sfc: true,
      props: props,
      $i18n: $i18n,
      growthFactorTitle: growthFactorTitle,
      IMPACT_SECTION_IDS: IMPACT_SECTION_IDS,
      TemplateEngineContext: TemplateEngineContext
    };
  }
});